const HOST = ZhbHost;

const linkAnalysisApi = {
  // 获取token
  getMidToken: `${HOST}/corpwx/api/v1/basic/getMidToken`,
};

export { linkAnalysisApi };
